export default "__VITE_ASSET__BNCo5kQB__"